import React, { Fragment, Component } from 'react'
import {
    Row, Col,
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse, ButtonGroup, Table
} from "reactstrap"
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'
// import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, } from "availity-reactstrap-validation"

import { Redirect } from "react-router-dom"
import apiResponse from '../../../../../../services/apiResponse'

import { cancelToken } from '../../../../../../services/adapters/kepegawaian/menuService'
import IndexBloc from '../Blocs/IndexBloc'

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class CancelModal extends Component {
    indexBloc = new IndexBloc();
    source

    constructor(props) {
        super(props);
        this.state = {
            dataForm: null,
            loadingDetail: true,
            redirect: false,
            dataSelected: []
        }
    }

    handleChecked = (e, uuid) => {
        var checked = e.target.checked;
        if (checked){
          this.setState({
            dataSelected : [
              ...this.state.dataSelected,
              uuid
            ]
          })
        } else {
          var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
          this.setState({
            dataSelected : filteredAry
          })
        }
        console.log(uuid, checked);
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.uuid,
                detail_uuids: this.state.dataSelected,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.indexBloc.fetchCancelAdmin(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    // redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail(uuid) {
        this.setState({
            loadingDetail: true
        })
        const query = { 
            uuid: uuid
        }
        this.indexBloc.fetchDetail(query, this.props.token)
    }

    componentDidMount() {

        this.indexBloc.cancelAdminChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        dataSelected: []
                    });
                    this.loadDetail()
                    this.props.toggle()
                    this.props.reload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:

                    // set state for every checkbox
                    for (let i = 0; i < result.data.response?.details.length; i++) {
                        let thisId = result.data.response?.details[i].paid_leave_detail_id
                        this.setState({
                            [`check${thisId}`] : false
                        })
                    }

                    this.setState({ 
                        detail: result.data.response,
                        loadingDetail: false
                    })
                    break;
                default:
                    break;
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.uuid !== this.props.uuid) {
            if (this.props.uuid) {
                this.loadDetail(this.props.uuid)
                this.setState({
                    dataSelected: []
                })
            }
        }
    }

    componentWillUnmount(){
        this.indexBloc.cancelAdminChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { presensi } = this.props
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Batalkan Cuti</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Jenis Cuti
                                </Label>
                                <Col md="4">
                                    { this.state.detail ? 
                                        <Label className="col-form-label">
                                            {this.state.detail?.paid_leave_type_full_name}
                                        </Label>
                                        :
                                        <Shimmer>
                                            <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                        marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                        </Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Tanggal Cuti
                                </Label>
                                <Col md="8">
                                    { this.state.detail ? 
                                        <Label className="col-form-label">
                                            {`${reformatDate(this.state.detail?.paid_leave_start_date)} s.d ${reformatDate(this.state.detail?.paid_leave_end_date)}`}
                                        </Label>
                                        :
                                        <Shimmer>
                                            <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                        marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                        </Shimmer>
                                    }
                                </Col>
                            </Row>

                            <Table>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Tanggal</th>
                                        <th>Status</th>
                                        <th>Batalkan?</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.loadingDetail ?
                                            <tr>
                                                <td colSpan={4}>
                                                    <Shimmer><div style={{width: '100%', height: 30}}></div></Shimmer>
                                                </td>
                                            </tr>
                                        : 
                                            this.state.detail &&
                                                this.state.detail.details?.map((val, i) => {
                                                    let disabledBatal = false;
                                                    if (val.paid_leave_detail_status != 1) {
                                                        disabledBatal = true;
                                                    }
                                                    return(
                                                        <tr key={i}>
                                                            <td>{i+1}</td>
                                                            <td>{reformatDate(val.paid_leave_detail_date, true)}</td>
                                                            <td>{val.paid_leave_detail_status_name}</td>
                                                            <td className="text-center">
                                                                {/* <AvField
                                                                    name={`detail_uuid[${i}]`}
                                                                    // value={pemdisabledBatalan}
                                                                    type="checkbox"
                                                                    disabled={disabledBatal}
                                                                /> */}
                                                                <div className="form-check text-center font-size-16">
                                                                    <Input 
                                                                        type="checkbox" 
                                                                        className="form-check-input" 
                                                                        id={'checkbox' + val.paid_leave_detail_id }
                                                                        onChange={
                                                                        (event)=>{
                                                                            this.handleChecked(event, val.paid_leave_detail_uuid)
                                                                            this.setState({
                                                                                [`check${val.paid_leave_detail_id}`] : !this.state[`check${val.paid_leave_detail_id}`]
                                                                            })
                                                                        }
                                                                        }
                                                                        checked={this.state[`check${val.paid_leave_detail_id}`]}
                                                                        disabled={disabledBatal}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                    }
                                </tbody>
                            </Table>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                                <Button color="primary" type="submit" disabled={this.state.dataSelected.length < 1 ? true : false}>Submit</Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

                {/* { this.state.redirect &&
                    <Redirect to="/izinpegawai/cuti.html" />
                } */}

            </Fragment>
        )
    }
}

export default CancelModal;